import { formatClock, timestampsDiffer } from '@cwos/ui-shared';
export function resolveDualTimestamp({ occurredAt, receivedAt }, thresholdMs = 60_000) {
    const occurred = new Date(occurredAt);
    const received = new Date(receivedAt);
    const split = timestampsDiffer({ occurredAt: occurred, receivedAt: received }, thresholdMs);
    return {
        split,
        occurred: formatClock(occurred),
        received: formatClock(received),
    };
}
//# sourceMappingURL=punchTimes.js.map